@if (!props.hidden && props.template) {
<div [ngClass]="props.cssClass"
  (click)="onTemplateClick($event)"
  [innerHTML]="getTemplateContent()"></div>
}